//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";



//--------------- FUNÇÃO ASSÍNCRONA UPDATE USER SERVICE ---------------//
// Responsável por requisitar à API a Atualização do Usuário
export default async function updateUserService(userIdEdited, payload) {
    if (!payload.nome || !payload.email || (!payload && !payload.senha)) {
        toast.warn("Preencha todos os campos obrigatórios");
        return false;
    }
    try {
        await api.put(`/usuarios/${userIdEdited}`, payload);
        toast.success("Usuário atualizado com sucesso");
        return true;
    } catch (err) {
        toast.error("Erro ao atualizar usuário")
        return false;
    }
}